export default {
  order: {
    payoutDetail: {
      title: {
        completed: 'How you were paid',
        incomplete: 'How you\'ll get paid',
        incompletePayout: 'How you\'ll get paid',
      },
      payoutTypeBadge: {
        paypal: 'Linked account',
        ach: 'Bank deposit',
        reverb: 'Info needed',
        wallet: 'Wallet',
      },
      payoutTypePrimaryAction: {
        addPayout: 'Add payout details',
        editSettings: 'Edit settings',
        viewPayout: 'View payout history',
      },
      hintText: {
        reverb: {
          completed: 'Earnings were sent to your payout balance. However, we\'re missing details that allow us to send you money.',
          incomplete: 'We\'re missing details that allow us to send you money.',
        },
        ach: {
          completed: 'Earnings were sent to your payout balance, which was deposited to your bank account. Deposits can take 1-4 business days. %{linkOpen}Learn more%{linkClose}',
          incomplete: 'Once your payout is approved your earnings will be deposited to your bank account.',
        },
        wallet: {
          completed: 'Earnings were sent to your Reverb Wallet.',
          incomplete: 'Once your payout is approved your earnings will be automatically transferred to your Reverb Wallet.',
        },
        paypal: {
          completed: 'Earnings were transferred to your linked PayPal account. Deposits should be available within a few minutes. %{linkOpen}Learn more%{linkClose}',
          incomplete: 'Once payment clears, your earnings will be transferred to your linked PayPal account. %{linkOpen}Learn more%{linkClose}',
          incompletePayout: 'Once your payout is approved, your earnings will be transferred to your linked PayPal account. %{linkOpen}Learn more%{linkClose}',
        },
      },
    },
  },
};
